import React from 'react';
import { Platform } from 'react-native';
import { useDispatch } from 'react-redux';
import { Box, BodyText, AbsoluteView, Title } from 'modules/styled';
import QRCodeScanner from 'react-native-qrcode-scanner';
import { RNCamera as Camera } from 'react-native-camera';
import { storage } from 'app/utils';
import { loginUserSuccess, getUser } from 'modules/auth/auth.actions';
import { hideModal } from 'modules/navigation/navigation.actions';
import { fullHeight } from 'styles/global';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export default function ConnectDesktop() {
  const dispatch = useDispatch();
  const { bottom } = useSafeAreaInsets();

  const onRead = async (e) => {
    const token = e.data;
    await storage.setToken(token);
    dispatch(loginUserSuccess(token));
    dispatch(getUser());
    dispatch(hideModal());
  };

  return (
    <Box
      style={{
        minHeight: fullHeight - 2 * 48 - bottom,
      }}
    >
      <AbsoluteView sx={{ left: -32, top: Platform.OS === 'android' ? '-48px' : '0' }}>
        <QRCodeScanner
          topViewStyle={{ flex: 1, alignItems: 'flex-start' }}
          topContent={
            <Box sx={{ p: 2 }}>
              <Title>Log in with Desktop Browser</Title>
            </Box>
          }
          cameraStyle={{
            overflow: 'hidden',
          }}
          cameraProps={{ flashMode: Camera.Constants.FlashMode.auto }}
          onRead={onRead}
          bottomViewStyle={{ flex: 1, alignItems: 'flex-start' }}
          bottomContent={
            <Box sx={{ p: 2 }}>
              <Title>Instructions:</Title>
              <BodyText sx={{ mt: 1 }}>
                1. Go to relevant.community on your computer
              </BodyText>
              <BodyText sx={{ mt: 4.01 }}>
                2. Log in and navigate to your profile
              </BodyText>
              <BodyText sx={{ mt: 4.01 }}>3. Click 'Connect Mobile Device'</BodyText>
              <BodyText sx={{ mt: 4.01 }}>4. Scan the QR code</BodyText>
            </Box>
          }
        />
      </AbsoluteView>
    </Box>
  );
}
